/**
 * Checks whether the provided array is empty or not.
 * @param input array
 * @returns boolean
 */
export const isEmptyArrayUtil = (input) => !input.length;
export default isEmptyArrayUtil;
